"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var timestamp_exports = {};
__export(timestamp_exports, {
  dateToTimestamp: () => dateToTimestamp,
  epochTimestamp: () => epochTimestamp,
  formatTimestamp: () => formatTimestamp,
  formatTimestampAgo: () => formatTimestampAgo,
  formatTimestampIso8601: () => formatTimestampIso8601,
  isValidTimestamp: () => isValidTimestamp,
  iso8601Timestamp: () => iso8601Timestamp,
  nowTimestamp: () => nowTimestamp,
  parseAnyTimestamp: () => parseAnyTimestamp,
  parseTimestamp: () => parseTimestamp,
  timestampEpoch: () => timestampEpoch,
  timestampEq: () => timestampEq,
  timestampGt: () => timestampGt,
  timestampGte: () => timestampGte,
  timestampLt: () => timestampLt,
  timestampLte: () => timestampLte,
  timestampNeq: () => timestampNeq,
  timestampToDate: () => timestampToDate
});
module.exports = __toCommonJS(timestamp_exports);
var import_guard = require("@cartographerio/guard");
var import_tz = require("@date-fns/tz");
var import_format = require("date-fns/format");
var import_formatDistance = require("date-fns/formatDistance");
var import_parse = require("date-fns/parse");
var import_parseISO = require("date-fns/parseISO");
var import_format2 = require("./format.js");
var import_timeZone = require("./timeZone.js");
var import_types_generated = require("./types.generated.js");
function isValidTimestamp(value) {
  return (0, import_guard.hasTypeTag)(value, "Timestamp") && (0, import_guard.hasKeyOfAnyType)(value, "iso8601") && (0, import_format2.isIso8601)(value.iso8601);
}
function timestampToDate(timestamp) {
  return (0, import_parseISO.parseISO)(timestamp.iso8601);
}
function dateToTimestamp(date) {
  return {
    type: "Timestamp",
    iso8601: date.toISOString()
  };
}
function nowTimestamp() {
  return dateToTimestamp(/* @__PURE__ */ new Date());
}
function epochTimestamp(epoch) {
  return dateToTimestamp(new Date(epoch));
}
function iso8601Timestamp(iso8601) {
  return {
    type: "Timestamp",
    iso8601
  };
}
function parseTimestamp(string, format2, reference = /* @__PURE__ */ new Date(), options) {
  try {
    return dateToTimestamp(
      (0, import_parse.parse)(string, format2, (0, import_types_generated.isTimestamp)(reference) ? timestampToDate(reference) : reference, options)
    );
  } catch (exn) {
    return void 0;
  }
}
const parseAnyTimestamp = (param) => parseTimestamp(param, import_format2.yyyymmdd) ?? parseTimestamp(param, import_format2.ddmmyyyy);
function formatTimestamp(timestamp, opts = {}) {
  const { timeZone = import_timeZone.defaultTimeZone, format: fnt = import_format2.defaultTimestampFormat } = opts;
  const utc2 = (0, import_parseISO.parseISO)(timestamp.iso8601);
  const zoned = new import_tz.TZDate(utc2, timeZone);
  return (0, import_format.format)(zoned, fnt);
}
function formatTimestampIso8601(timestamp) {
  return formatTimestamp(timestamp, {
    timeZone: import_timeZone.utc,
    format: import_format2.iso8601TimestampFormat
  });
}
function formatTimestampAgo(timestamp, now = nowTimestamp()) {
  const tsDate = timestampToDate(timestamp);
  const nowDate = timestampToDate(now);
  const distance = (0, import_formatDistance.formatDistance)(tsDate, nowDate);
  return nowDate.getTime() > tsDate.getTime() ? `${distance} ago` : `in ${distance}`;
}
function timestampEpoch(timestamp) {
  return timestampToDate(timestamp).getTime();
}
function timestampEq(x, y) {
  return timestampEpoch(x) === timestampEpoch(y);
}
function timestampNeq(x, y) {
  return timestampEpoch(x) !== timestampEpoch(y);
}
function timestampGt(x, y) {
  return timestampEpoch(x) > timestampEpoch(y);
}
function timestampLt(x, y) {
  return timestampEpoch(x) < timestampEpoch(y);
}
function timestampGte(x, y) {
  return timestampEpoch(x) >= timestampEpoch(y);
}
function timestampLte(x, y) {
  return timestampEpoch(x) <= timestampEpoch(y);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  dateToTimestamp,
  epochTimestamp,
  formatTimestamp,
  formatTimestampAgo,
  formatTimestampIso8601,
  isValidTimestamp,
  iso8601Timestamp,
  nowTimestamp,
  parseAnyTimestamp,
  parseTimestamp,
  timestampEpoch,
  timestampEq,
  timestampGt,
  timestampGte,
  timestampLt,
  timestampLte,
  timestampNeq,
  timestampToDate
});
//# sourceMappingURL=timestamp.js.map
